<div class="app-layout-overlapped-main">
  <!-- component where any screen show modals full screen -->
  <core-layout-modals-overlapped></core-layout-modals-overlapped>
  <!-- Ribbon when system was updated is here to overlap any screen -->
  <core-helpers-updated-ribbon-button *ngIf="status.value == appStatus.VERSION_CHANGED"></core-helpers-updated-ribbon-button>
  <!-- Ribbon when connection was lost some time and web need to be updated, is here to overlap any screen -->
  <core-helpers-disconnected-ribbon-button *ngIf="status.value == appStatus.DISCONNECTED"></core-helpers-disconnected-ribbon-button>
  <!-- component where any screen show notifications inside, right side of the screen -->
  <app-layout-overlapped-notifications></app-layout-overlapped-notifications>
</div>